import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Game from '../views/Game.vue';
import JoinUsCampus from '../views/JoinUsCampus.vue'
import CampusJobDetails from '../views/CampusJobDetails.vue'
import JoinUsSocial from '../views/JoinUsSocial.vue'
import SocialJobDetails from '../views/SocialJobDetails.vue'
import About from '../views/About.vue';
import Privacy from "../views/Privacy.vue";
import Terms from "../views/Terms.vue";
import DataDelete from "../views/DataDelete.vue";


Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/game',
    name: 'game',
    component: Game
  },
  {
    path: '/data_delete',
    name: 'data_delete',
    component: DataDelete
  },
  {
    path: '/join_campus',
    name: 'join_campus',
    component: JoinUsCampus
  },
  {
    path: '/join_campus_details',
    name: 'join_campus_details',
    component: CampusJobDetails,
  },
  {
    path: '/join_social',
    name: 'join_social',
    component: JoinUsSocial
  },
  {
    path: '/join_social_details',
    name: 'join_social_details',
    component: SocialJobDetails,
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: Privacy
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms
  },
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js